import { removeAccentuation } from './strings';

export function isCypressActived() {
  return !!window?.Cypress;
}

export function normalizeCyData(value: string) {
  return removeAccentuation(value.trim().split(' ').join('-').toLowerCase());
}
